// РУКА 2. Как витрина считает цены. Одни формулы для плитки, карточки, комплекта и корзины.
import type { KitView, ProductView } from "@/contract";

// Цена со скидкой на товар — до целого рубля.
export function salePrice(p: Pick<ProductView, "priceRetail" | "discountPercent">): number {
  return p.discountPercent ? Math.round((p.priceRetail * (100 - p.discountPercent)) / 100) : p.priceRetail;
}

// Комплект: по отдельности (каждый товар по своей цене), комплектом (минус скидка комплекта), выгода.
export function kitPrices(kit: KitView) {
  const separate = kit.items.reduce((s, i) => s + salePrice(i.product) * i.qty, 0);
  const together = kit.discountPercent ? Math.round((separate * (100 - kit.discountPercent)) / 100) : separate;
  return { separate, together, benefit: separate - together };
}
